import React, { FC, useState, useEffect, useRef } from 'react'
import moment from 'moment'

import { Spin, Collapse, ConfigProvider, Form, Col, Row } from 'antd'
import { CustomDataEmpty } from 'components/customDataEmpty'
import SearchableColumn from 'components/Table/ColumnSearch'
import SelectField from 'components/SelectField'
import CustomTooltip from "components/Tooltip"

import { Deposit, getDeposits } from '../../../../services/Deposits/Deposits'
import { Spinner } from 'constants/constants'
import { getCurrentCompany } from '../../../../services/user'
import { financial } from '../../../../services/helper'

import { updateAccountNickname } from '../../../../services/Accounts/AccountNickname'
import ActiveTableList from './ActiveTableList'
import ClosedTableList from './ClosedTableList'
import { useTranslation } from 'react-i18next'
import { useConveyer } from "@egjs/react-conveyer";

import './index.scss'

const { Panel } = Collapse
interface DepositListProps {
  className?: string
}

export const DepositList: FC<DepositListProps> = ({ className }) => {
  const {t} = useTranslation()
  const ref = useRef<HTMLDivElement>(null);
  useConveyer(ref, {
    horizontal: true,
  });
  const [tableData, setTableData] = useState<Deposit[]>()
  const [filteredData, setFilteredData] = useState<Deposit[]>()
  const [filteredDeactivData, setFilteredDeactiveData] = useState<Deposit[]>()
  const [isFiltered, setIsFiltered] = useState(false)
  const [deactiveTableData, setDeactiveTableData] = useState<Deposit[]>()
  const [tableLoading, setTableLoading] = useState(Spinner)
  const [panel, setPanel] = useState(false)
  const [expandedPanelTableKeys, setExpandedPanelTableKeys] = useState([])
  const [expandedRowKeys, setExpandedRowKeys] = useState([])
  const [selectedCurrency, setSelectedCurrency] = useState(t("common.all"))
  const [firstRow, setFirstRow] = useState(false)
  const [form] = Form.useForm()

  const fetchData = async () => {
    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    const data = await getDeposits(getCurrentCompany())

    const filter_active_data = data.filter((row) => row.STATUS === '1')
    const filter_deactive_data = data.filter((row) => row.STATUS !== '1')
    const newData = filter_active_data.map((object) => {
      return { ...object, key: parseInt(object.ACCOUNT_NO), isExpandable: false }
    })

    const newDataDeactive = filter_deactive_data.map((object) => {
      return { ...object, key: parseInt(object.ACCOUNT_NO), isExpandable: false }
    })
    setTableData(newData)
    setDeactiveTableData(newDataDeactive)

    setTableLoading({
      ...tableLoading,
      spinning: false,
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  const onRow = (item) => {
    expandedRowKeys.includes(item.key) && { className: 'expand-parent' }
  }


  const onTableRowExpand = (expanded: boolean, record: any) => {
    const keys = [];
    if (record.isExpandable === false) {
      if (expanded) {
        handleRowClose('second')
        keys.push(record.key);
      }
      setExpandedRowKeys(keys);
    }

  }
  const onFirstTableRowExpand = (expanded: boolean, record: string) => {
    const keys: any = [];
    if (record.isExpandable === false) {
      if (expanded) {
        handleRowClose('first')
        keys.push(record.key);
      }
      setExpandedPanelTableKeys(keys);
    }

  }

  const handleRowClose = (type: string) => {
    type === 'first' ? setExpandedRowKeys([]) : setExpandedPanelTableKeys([])
  }

  const onRowPanel = (item) =>
    expandedPanelTableKeys.includes(item.key) && { className: 'expand-parent' }

  const onClosePanel = () => {
    handleRowClose('second')
    setPanel(!panel)
  }

  const customizeRenderEmpty = () => (
    <CustomDataEmpty value={t("deposit.noDeposits")} />
  )

  // const filterHandler = (value: any, columnName: string) => {
  //   const filtered = tableData?.filter((row) => {
  //     return row[columnName].toUpperCase().match(value.toUpperCase())
  //   })
  //   const filteredDeactiveData = deactiveTableData?.filter((row) => {
  //     return row[columnName].toUpperCase().match(value.toUpperCase())
  //   })

  //   setIsFiltered(true)
  //   setFilteredData(filtered)
  //   setFilteredDeactiveData(filteredDeactiveData)
  //   if (value == 'all') {
  //     form.resetFields(['CCY_NAME'])
  //     setIsFiltered(false)
  //   }
  // }

  const currencyFilter = [
    {
      label: t("common.all"),
      value: 'all',
    },
    {
      label: 'AZN',
      value: 'AZN',
    },
    {
      label: 'USD',
      value: 'USD',
    },
    {
      label: 'RUB',
      value: 'RUB',
    },
    {
      label: 'EUR',
      value: 'EUR',
    },
    {
      label: 'GBP',
      value: 'GBP',
    },
  ]

  const [filtereValues, setFilteredValues] = useState({ "col_1": "", "col_2": "", "col_6": "" })

  const handleFilterColumn = (e: any, column: string) => {

    let newfiltereValues = filtereValues;

    if (column === 'nickName') {
      newfiltereValues.col_1 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'IBAN') {
      newfiltereValues.col_2 = e.target.value?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }

    if (column === 'CCY_NAME') {
      newfiltereValues.col_6 = e?.toLowerCase()
      setFilteredValues(newfiltereValues)
    }


    if (tableData && deactiveTableData && filtereValues) {

      let filteredData;

      filteredData = tableData?.filter(sRow => sRow.CCY_NAME.toLowerCase().includes(filtereValues["col_6"]) && (sRow.nickName ? sRow.nickName?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_1"]) : sRow.PRODUCT_NAME?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_1"])) && sRow.IBAN?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_2"]));


      let filteredDataDeactive;

      filteredDataDeactive = deactiveTableData?.filter(sRow => sRow.CCY_NAME.toLowerCase().includes(filtereValues["col_6"]) && (sRow.nickName ? sRow.nickName?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_1"]) : sRow.PRODUCT_NAME?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_1"])) && sRow.IBAN?.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_2"]));

      setFilteredDeactiveData(filteredDataDeactive)
      setIsFiltered(true)
      setFilteredData(filteredData)

      if (filtereValues["col_6"] === 'all') {
        form.resetFields(['currency_filter'])
      }
    }
  }


  const firstTableColumnsData = [
    {
      title: (
        <div style={{ display: 'block', width: 160 }}>
          <Form
            form={form}
          >
            <SearchableColumn
              onChange={(event: any) => handleFilterColumn(event, 'nickName')}
              onBlur={() => setIsFiltered(false)}
              large
              title={t("deposit.depositName")}
              form={form}
              name={"nickname"}
              filter={"searchfilter"}
            />
          </Form>
        </div>
      ),
      render: (data: any, record: any) => {
        return (
          <>
            <p className=" align_center not_open_popup">
              <div className={'not_open_popup account_edit_nickname'} id='account_edit_nickname' onClick={() => setFirstRow(true)}>
                <Form form={form}>
                  <SearchableColumn
                    large
                    title={data ? (data.split('').length > 27 ? <CustomTooltip title={data}>{data}</CustomTooltip> : data) : record['PRODUCT_NAME']}
                    customIcon={true}
                    form={form}
                    maxLength={35}
                    allowClear={true}
                    value={data ? data : record['PRODUCT_NAME']}
                    name={'updateAccountName'}
                    /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                    onBlur={(e: any) => updateAccountName(e, record)}
                  />
                </Form>
              </div>
            </p>
          </>
        )
      },
      dataIndex: 'nickName',
      key: 'nickName',
      className: 'big-column',
      //   onCell: () => {             
      //     return {
      //         onClick: () => {
      //           setFirstRow(true)
      //         },
      //     };
      // },

      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = true;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = true;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
      // sorter: (a:any, b:any) => a.depositName.localeCompare(b.depositName),
    },
    {
      title: (
        <div style={{ width: 217 }}>
          <Form
            form={form}
          >
            <SearchableColumn
              onChange={(event: any) => handleFilterColumn(event, 'IBAN')}
              onBlur={() => setIsFiltered(false)}
              large
              title={t("deposit.accountNumber")}
              form={form}
              name={"iban"}
              filter={"searchfilter"}
            />
          </Form>
        </div>
      ),
      render: (text: string) => (
        <span className={'creditList__invoiceNumber'}>{text}</span>
      ),
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
      dataIndex: 'IBAN',
      key: 'IBAN',
      editable: false,
    },
    {
      title: (
        <span className={'credit-table__title credit-table__title-center'}>
          {t("deposit.startDate")}
        </span>
      ),
      dataIndex: 'OPENDATE',
      key: 'OPENDATE',
      editable: false,
      render: (text: string) => (
        <div className={'deposit-cell'}>{text}</div>
      ),
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
    },
    {
      title: (
        <span
          className={'credit-table__title credit-table__title-center'}
        >
          {t("salary.expiryDate")}
        </span>
      ),
      dataIndex: 'MATURITY_DATE',
      key: 'MATURITY_DATE',
      render: (text: string) => (
        <div className={'deposit-cell'}>{text}</div>
      ),
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
      // sorter: (a:any, b:any) =>  moment(a.endDate).unix() - moment(b.endDate).unix(),
    },
    {
      title: (
        <span
          className={'credit-table__title credit-table__title-center'}
          style={{ width: 82 }}
        >
          {t("deposit.interestRate")}
        </span>
      ),
      dataIndex: 'INTEREST_RATIO',
      key: 'INTEREST_RATIO',
      render: (text: string) => (
        <span
          className={'credit-table__text credit-table__title-center'}
          style={{ width: 82 }}
        >
          {text}%
        </span>
      ),
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
      // sorter: (a, b) => console.log(moment(a.date), moment(a.date).unix(), moment(a.date).unix()),
    },
    {
      title: (
        <div className="flex">
          <div className="filterable-column">
            <Form form={form}>
              {t("home.currency")}
              <SelectField
                // open={true}
                width={70}
                placeholder={t("common.all")}
                options={currencyFilter}
                dropdownClassName="currency-filter-dropdown"
                className="status-select"
                onChange={(event: any) => handleFilterColumn(event, 'CCY_NAME')}
                name={'currency_filter'}
                label
              />
            </Form>
          </div>
        </div>
      ),
      dataIndex: 'CCY_NAME',
      key: 'CCY_NAME',
      className: 'big-column',
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
    },
    {
      title: (
        <span className={'credit-table__title credit-table__title-center'}>
          {t("accountStatement.balance")}
        </span>
      ),
      render: (record: any, text: string) => {
        return <p style={{ textAlign: 'center' }}>{financial(record)}</p>
      },
      dataIndex: 'BALANCE',
      key: 'BALANCE',
      className: 'big-column',
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
    },
    {
      title: <span className={'credit-table__title credit-table__title-center'}>{t("home.availableBalance")}</span>,
      dataIndex: 'BALANCE_LC',
      key: 'BALANCE_LC',
      className: 'big-column',
      render: (record: any, text: string) => {
        return <div className={'deposit-cell'}>{financial(record)}</div>
      },
      onCell: (record: any, index: number) => {
        return {
          onClick: () => {
            if (record.STATUS === "1") {
              const newtableData: any = tableData;
              newtableData[index]["isExpandable"] = false;
              setTableData(newtableData);
            } else {
              const neweActivetableData: any = deactiveTableData;
              neweActivetableData[index]["isExpandable"] = false;
              setDeactiveTableData(neweActivetableData);
            }
          },
        };
      },
    },
  ]

  const updateAccountName = (e: any, row: any) => {
    e.preventDefault()
    e.stopPropagation()
    setFirstRow(false)
    setExpandedRowKeys([])
    setExpandedPanelTableKeys([])
    let value = e.target.value.trim()
    let check_value = value

    const requestData = {
      IBAN: row.IBAN,
      NICKNAME: check_value,
    }

    setTableLoading({
      ...tableLoading,
      spinning: true,
    })

    updateAccountNickname(requestData).then((res) => {
      fetchData()
    })
  }

  return (
    <Spin {...tableLoading}>
      <ConfigProvider renderEmpty={customizeRenderEmpty}>
        <div className={`depositList creditList ${className}`} ref={ref}>
          {tableData?.length > 0 && deactiveTableData?.length > 0 ? (
            <>
              <ActiveTableList
                columns={firstTableColumnsData}
                expandedRowKeys={expandedRowKeys}
                onExpand={onTableRowExpand}
                firstRow={firstRow}
                // onChange={handleChange}
                notExpanDable="nickName"
                handleRowClose={() => handleRowClose('first')}
                onRow={onRow}
                data={isFiltered == true ? filteredData : tableData}
              />
              <ClosedTableList
                panel={panel}
                // defaultActiveKey={['1']}
                onClosePanel={() => onClosePanel()}
                firstRow={firstRow}
                handleRowClose={handleRowClose}
                columns={firstTableColumnsData}
                data={isFiltered == true ? filteredDeactivData : deactiveTableData}
                isClosedDeposites={true}
                expandedRowKeys={expandedPanelTableKeys}
                onExpand={onFirstTableRowExpand}
                onRow={onRowPanel} />

            </>
          ) : tableData?.length == 0 && deactiveTableData?.length > 0 ? (
            <div className='table-panel'>
              <ActiveTableList
                columns={firstTableColumnsData}
                expandedRowKeys={expandedRowKeys}
                onExpand={onTableRowExpand}
                firstRow={firstRow}
                // onChange={handleChange}
                notExpanDable="nickName"
                handleRowClose={() => handleRowClose('first')}
                onRow={onRow}
                data={isFiltered == true ? filteredData : tableData}
              />
              <ClosedTableList
                panel={panel}
                onClosePanel={() => onClosePanel()}
                firstRow={firstRow}
                handleRowClose={handleRowClose}
                columns={firstTableColumnsData}
                data={isFiltered == true ? filteredDeactivData : deactiveTableData}
                isClosedDeposites={false}
                expandedRowKeys={expandedPanelTableKeys}
                onExpand={onFirstTableRowExpand}
                onRow={onRowPanel} />
            </div>
          ) : (tableData?.length > 0 && deactiveTableData?.length == 0 ?
            <ActiveTableList
              columns={firstTableColumnsData}
              expandedRowKeys={expandedRowKeys}
              onExpand={onTableRowExpand}
              // onChange={handleChange}
              firstRow={firstRow}
              handleRowClose={() => handleRowClose('first')}
              onRow={onRow}
              data={isFiltered == true ? filteredData : tableData} />
            : <><ActiveTableList
              columns={firstTableColumnsData}
              expandedRowKeys={expandedRowKeys}
              onExpand={onTableRowExpand}
              // onChange={handleChange}
              firstRow={firstRow}
              handleRowClose={() => handleRowClose('first')}
              onRow={onRow}
              data={isFiltered == true ? filteredData : tableData} />
              <CustomDataEmpty value={t("deposit.noDeposits")} /></>)
          }
        </div>
      </ConfigProvider>
    </Spin>
  )
}
